// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5443) return "static/chunks/ad7f724d-365d834f95d30707.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"9b1280c9a6cc6105","6350":"a4b650c88c962d42","7856":"ad1e1bcca69c641e","9050":"e66f20c0824f39b5","9679":"8c75641ed8acbec9"}[chunkId] + ".js";
};